module.exports = __webpack_public_path__ + "img/kuang3.8954286e.png";